var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_299_1419)","key":0},React.createElement("path",{"d":"M9.5 8.5C9.5 7.11875 10.6188 6 12 6C12.9969 6 13.8562 6.58125 14.2594 7.42812C14.4969 7.92812 15.0938 8.14062 15.5906 7.90313C16.0875 7.66563 16.3031 7.06875 16.0656 6.57188C15.3438 5.05313 13.7969 4 12 4C9.51562 4 7.5 6.01562 7.5 8.5V10H7C5.89688 10 5 10.8969 5 12V18C5 19.1031 5.89688 20 7 20H17C18.1031 20 19 19.1031 19 18V12C19 10.8969 18.1031 10 17 10H9.5V8.5Z","fill":"#1DA1F2"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_299_1419"},React.createElement("rect",{"width":"14","height":"16","fill":"white","transform":"translate(5 4)"})))]);
}

Lock.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Lock;

Lock.default = Lock;
